module.exports = __webpack_public_path__ + "static/media/icons_Bilan Parkinson.4d54af4b.svg";